import React from "react";
import { useSeller } from "../../contexts/SellerContext";
const LotDetailsDrawer = ({
  lotDrawerOpen,
  closeLotDrawer,
  drawerLotSizes,
  setDrawerLotSizes,
  fieldErrors,
  Lot,
  activeTab,
  handleSizeChange,
  handleAddLotSize,
  handleSaveLot,
  getSizeOptions,
  sizeAverages,
  totals,
}) => {
  const { seller } = useSeller();
  if (!lotDrawerOpen) return null;

  const segment = seller?.segment;
  // Carat weight is only relevant for gem & pearl products
  const segmentUpper = (segment || "").toUpperCase();
  const showcaratRate = segmentUpper === "GEMS" || segmentUpper === "PEARL";
  const showPriceInput =
    segmentUpper === "DECOR" ||
    segmentUpper === "BRAND" ||
    segmentUpper === "TOOL" ||
    segmentUpper === "MACHINE";
  console.log(segment);
  return (
    <div className="lot-drawer-overlay" onClick={closeLotDrawer}>
      <div className="lot-drawer" onClick={(e) => e.stopPropagation()}>
        <div className="drawer-header">
          <h3>Add {Lot ? "Lot" : "Single"} Details</h3>
          <button className="close-btn" onClick={closeLotDrawer}>
            ×
          </button>
        </div>

        <div className="drawer-body">
          <div className="size-input-section">
            <h4>Add Size Details</h4>
            {drawerLotSizes.map((item, index) => (
              <div key={index} className="size-row" data-row-index={index}>
                <div className="form-group">
                  <label>Size</label>
                  <select
                    value={item.size}
                    onChange={(e) =>
                      handleSizeChange(index, "size", e.target.value)
                    }
                    data-row-index={index}
                  >
                    <option value="">Select Size</option>
                    {getSizeOptions()
                      .filter((size) => {
                        const isTaken = drawerLotSizes.some(
                          (item, i) => i !== index && item.size === size,
                        );
                        return !isTaken;
                      })
                      .map((size) => (
                        <option key={size} value={size}>
                          {size}
                        </option>
                      ))}
                  </select>
                </div>

                {activeTab === "ready" && (
                  <div className="form-group">
                    <label>Total Set</label>
                    <input
                      type="number"
                      value={item.set}
                      required
                      onChange={(e) =>
                        handleSizeChange(index, "set", e.target.value)
                      }
                      data-row-index={index}
                    />
                    {fieldErrors[`${index}-set`] && (
                      <span className="error-text">
                        {fieldErrors[`${index}-set`]}
                      </span>
                    )}
                  </div>
                )}

                {activeTab === "ready" && !showPriceInput && (
                  <div className="form-group">
                    <label>
                      Total Gross Wt.{showcaratRate ? "(Ct.)" : "(gm.)"}
                    </label>
                    <input
                      type="number"
                      step="0.001"
                      value={item.grossWt}
                      onChange={(e) =>
                        handleSizeChange(index, "grossWt", e.target.value)
                      }
                      data-row-index={index}
                    />
                    {fieldErrors[`${index}-grossWt`] && (
                      <span className="error-text">
                        {fieldErrors[`${index}-grossWt`]}
                      </span>
                    )}
                  </div>
                )}

                {activeTab === "ready" && !showPriceInput && (
                  <div className="form-group">
                    <label>
                      Total Net Wt. {showcaratRate ? "(Ct.)" : "(gm.)"}
                    </label>
                    <input
                      type="number"
                      step="0.001"
                      value={item.netWt}
                      onChange={(e) =>
                        handleSizeChange(index, "netWt", e.target.value)
                      }
                      data-row-index={index}
                    />
                    {fieldErrors[`${index}-netWt`] && (
                      <span className="error-text">
                        {fieldErrors[`${index}-netWt`]}
                      </span>
                    )}
                  </div>
                )}
                {showPriceInput && (
                  <div className="form-group">
                    <label>Price</label>
                    <input
                      type="number"
                      step="0.01"
                      value={item.price || ""}
                      onChange={(e) =>
                        handleSizeChange(index, "price", e.target.value)
                      }
                      data-row-index={index}
                    />
                    {fieldErrors[`${index}-price`] && (
                      <span className="error-text">
                        {fieldErrors[`${index}-price`]}
                      </span>
                    )}
                  </div>
                )}

                {showcaratRate && (
                  <div className="form-group">
                    <label>Carat Rate</label>
                    <input
                      type="number"
                      step="0.01"
                      value={item.caratRate || ""}
                      onChange={(e) =>
                        handleSizeChange(index, "caratRate", e.target.value)
                      }
                      data-row-index={index}
                    />
                    {fieldErrors[`${index}-caratrate`] && (
                      <span className="error-text">
                        {fieldErrors[`${index}-caratRate`]}
                      </span>
                    )}
                  </div>
                )}

                {activeTab === "order" && (
                  <div className="form-group">
                    <label>Total Gross Wt / Set (g)</label>
                    <input
                      type="number"
                      step="0.001"
                      value={item.avgGrossWt}
                      onChange={(e) =>
                        handleSizeChange(index, "avgGrossWt", e.target.value)
                      }
                      data-row-index={index}
                    />
                    {fieldErrors[`${index}-avgGrossWt`] && (
                      <span className="error-text">
                        {fieldErrors[`${index}-avgGrossWt`]}
                      </span>
                    )}
                  </div>
                )}

                {activeTab === "order" && (
                  <div className="form-group">
                    <label> Total Net Wt / Set (g)</label>
                    <input
                      type="number"
                      step="0.001"
                      value={item.avgNetWt}
                      onChange={(e) =>
                        handleSizeChange(index, "avgNetWt", e.target.value)
                      }
                      data-row-index={index}
                    />
                    {fieldErrors[`${index}-avgNetWt`] && (
                      <span className="error-text">
                        {fieldErrors[`${index}-avgNetWt`]}
                      </span>
                    )}
                  </div>
                )}

                {Lot === true && (
                  <button
                    type="button"
                    className="remove-size-btn"
                    onClick={() => {
                      const newSizes = drawerLotSizes.filter(
                        (_, i) => i !== index,
                      );
                      setDrawerLotSizes(newSizes);
                    }}
                    title="Remove this size"
                  >
                    ×
                  </button>
                )}
              </div>
            ))}

            {Lot && (
              <button
                type="button"
                onClick={handleAddLotSize}
                className="add-size-btn"
                disabled={
                  !Lot || drawerLotSizes.length >= getSizeOptions().length
                }
              >
                + Add More Size
              </button>
            )}
          </div>

          {sizeAverages.length > 0 && (
            <div className="size-averages-section">
              <h4>Size & Totals</h4>
              <div className="averages-table">
                <table>
                  <thead>
                    <tr>
                      <th>Size</th>
                      <th>Total Sets</th>
                       {showcaratRate ? (
                        <>
                          <th>Total carat Wt (g)</th>
                          <th>Total Net Wt (g)</th>
                        </>
                      ) : (
                        <>
                          {!showPriceInput && (
                            <>
                              {" "}
                              <th>Total Gross Wt (g)</th>
                              <th>Total Net Wt (g)</th>
                            </>
                          )}
                        </>
                      )}
                     {showcaratRate && <th> Carat Rate(ct)</th>}
                     {showPriceInput && <th>Price</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {sizeAverages.map((avg, index) => (
                      <tr key={index}>
                        <td>{avg.size}</td>
                        <td>{avg.totalSets}</td>

                        {!showcaratRate && !showPriceInput && (
                          <>
                            <td>{avg.averageGrossWt.toFixed(3)}</td>
                            <td>{avg.averageNetWt.toFixed(3)}</td>
                          </>
                        )}
                        {showPriceInput && (
                          <td>{(avg.averagePrice || 0).toFixed(2)}</td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="totals-row">
                      <td colSpan="1">Total</td>
                      <td>{totals.totalSets}</td>
                      {showcaratRate && (
                        <>
                          <td>{totals.totalGrossWt.toFixed(3)}</td>
                          <td>{totals.totalNetWt.toFixed(3)}</td>
                        </>
                      )}
                      {!showcaratRate && !showPriceInput && (
                        <>
                          <td>{totals.totalGrossWt.toFixed(3)}</td>
                          <td>{totals.totalNetWt.toFixed(3)}</td>
                        </>
                      )}
                      {showcaratRate && (
                        <td>{(totals.totalcaratRate || 0).toFixed(2)}</td>
                      )}
                      {showPriceInput && (
                        <td>{(totals.totalPrice || 0).toFixed(2)}</td>
                      )}
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          )}
        </div>

        <div className="drawer-footer">
          <button className="cancel-btn" onClick={closeLotDrawer}>
            Cancel
          </button>
          <button
            className="save-btn"
            onClick={handleSaveLot}
            disabled={
              drawerLotSizes.length === 0 ||
              !drawerLotSizes.every((item) => {
                const hasSize = (item.size || "").trim() !== "";
                if (activeTab === "ready") {
                  const setVal = parseFloat(item.set);
                  const grossVal = parseFloat(item.grossWt);
                  const netVal = parseFloat(item.netWt);
                  if (showPriceInput) {
                    return hasSize && !isNaN(setVal) && setVal > 0;
                  }
                  return (
                    hasSize &&
                    !isNaN(setVal) &&
                    setVal > 0 &&
                    !isNaN(grossVal) &&
                    grossVal > 0 &&
                    !isNaN(netVal) &&
                    netVal > 0 &&
                    netVal <= grossVal
                  );
                } else {
                  const avgGross = parseFloat(item.avgGrossWt);
                  const avgNet = parseFloat(item.avgNetWt);
                  if (showPriceInput) {
                    return hasSize;
                  }
                  return (
                    hasSize &&
                    !isNaN(avgGross) &&
                    avgGross > 0 &&
                    !isNaN(avgNet) &&
                    avgNet > 0 &&
                    avgNet <= avgGross
                  );
                }
              })
            }
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default LotDetailsDrawer;
